import { Component, OnInit } from '@angular/core';
import {UserBalanceService} from '../user-balance.service';
import {AuthorizationService} from '../../authorization/authorization.service';
import {Router} from '@angular/router';
import {SatPopover} from '@ncstate/sat-popover';

@Component({
  selector: 'app-user-balance',
  templateUrl: './user-balance.component.html',
  styleUrls: ['./user-balance.component.scss']
})
export class UserBalanceComponent implements OnInit {

  constructor(
    public userBalanceService: UserBalanceService,
    public authorizationService: AuthorizationService,
    public router: Router,
    public rightMenuPopover: SatPopover
  ) { }
  ngOnInit() {
}

  canReplenishBalance() {
    return !!this.authorizationService.getIdentity().user_billing_acquirer_id;
  }

  replenishBalance() {
    this.rightMenuPopover.toggle();
    this.router.navigate(['/user/user-list/' + this.authorizationService.getIdentity().id + '/top-up-balance-using-bank-card']);
  }

}
